/** Маппинг русских названий направлений на английские идентификаторы */
export const DIRECTION_NAME_TO_SLUG: Record<string, string> = {
  Футбол: 'football',
  Баскетбол: 'basketball',
  Плавание: 'swimming',
  Волейбол: 'volleyball',
  Гимнастика: 'gymnastics',
  Шахматы: 'chess',
  Хоккей: 'hockey',
  Теннис: 'tennis',
  Бокс: 'boxing',
  Лыжи: 'skiing',
  Бег: 'running',
}

export const DIRECTION_ICONS: Record<string, string> = {
  football: 'i-local-football',
  basketball: 'i-local-basketball',
  swimming: 'i-local-swimming',
  volleyball: 'i-local-volleyball',
  gymnastics: 'i-local-gymnastics',
  chess: 'i-local-chess',
  hockey: 'i-local-hockey',
  tennis: 'i-local-tennis',
  boxing: 'i-local-boxing',
  skiing: 'i-local-skiing',
  running: 'i-local-running',
}

/** Пути к иллюстрациям направлений (PNG из Figma, без фона) */
export const DIRECTION_ILLUSTRATIONS: Record<string, string> = {
  football: '/images/directions/football.webp',
  basketball: '/images/directions/basketball.webp',
  swimming: '/images/directions/swimming.webp',
  volleyball: '/images/directions/volleyball.webp',
  gymnastics: '/images/directions/gymnastics.webp',
  chess: '/images/directions/chess.webp',
  hockey: '/images/directions/hockey.webp',
  tennis: '/images/directions/tennis.webp',
  boxing: '/images/directions/boxing.webp',
  skiing: '/images/directions/skiing.webp',
  running: '/images/directions/running.webp',
}

export function getDirectionIcon(
  dir?: { name?: string; slug?: string } | null,
): string {
  if (!dir) return ''

  const slug = dir.slug
  if (slug) {
    const icon = DIRECTION_ICONS[slug]
    if (icon) return icon
  }
  const name = dir.name

  if (name) {
    const mappedSlug = DIRECTION_NAME_TO_SLUG[name]
    if (mappedSlug) {
      const icon = DIRECTION_ICONS[mappedSlug]
      if (icon) return icon
    }
  }
  return ''
}

export function getDirectionIllustration(name: string | undefined): string {
  if (!name) return ''

  return (
    DIRECTION_ILLUSTRATIONS[
      DIRECTION_NAME_TO_SLUG[name] as keyof typeof DIRECTION_ILLUSTRATIONS
    ] || ''
  )
}
